import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class QuestionService {
  static getQuestions(type, page) {
    return HttpUtil.get(
      API_ROUTES.QUESTIONS_DATA.GET_QUESTIONS
        .replace('<type>', type)
        .replace('<page>', page)
    );
  }

  static getPlatformStandard() {
    return HttpUtil.get(
      API_ROUTES.ESG_DATASET.GET_PLATFORM_STD
    );
  }

  static getPlatformStandardCodes(standard, category, platformCode) {
    return HttpUtil.get(
      API_ROUTES.ESG_DATASET.GET_PLATFORM_STD_CODE
        .replace('<standard>', standard)
        .replace('<category>', category)
        .replace('<platformCode>', platformCode)
    );
  }

  static saveQuestions(payload, isUpdate = false) {
    if (isUpdate) {
      return HttpUtil.put(
        API_ROUTES.QUESTIONS_DATA.SAVE_QUESTIONS, payload
      );
    } else {
      return HttpUtil.post(
        API_ROUTES.QUESTIONS_DATA.SAVE_QUESTIONS, payload
      );
    }
  }

  static deleteFullSetQuestions(type) {
    const encodedType = encodeURIComponent(type);
    return HttpUtil.delete(
      API_ROUTES.QUESTIONS_DATA.DELETE_FULL_QUESTIONS
        .replace('<type>', encodedType),
      {}
    );
  }

  static translateText(text, sLang, tLang) {
    return HttpUtil.postForTranslation(
      API_ROUTES.TEXT_TRANSLATOR.GET_TRANSLATION,
      {
        text: typeof (text) == 'string' ? [text] : text,
        source_lang: sLang,
        target_lang: tLang
      }
    );
  };

  static saveQuestionsPosition(payload) {
    return HttpUtil.post(
      API_ROUTES.QUESTIONS_DATA.SAVE_QUESTIONS_POSITION, payload
    );
  }
}
